import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modalStack, setModalStack] = useState([]);
  const [backgroundLocation, setBackgroundLocation] = useState(null);

  const pushModal = (modal) => {
    setModalStack((prev) => [...prev, modal]);
  };

  const popModal = () => {
    setModalStack((prev) => prev.slice(0, -1));
  };

  // console.log("Modal Provider:", backgroundLocation);

  return (
    <ModalContext.Provider value={{
      modalStack,
      pushModal,
      popModal,
      topModalId: modalStack[modalStack.length - 1]?.id,
      backgroundLocation,
      setBackgroundLocation
    }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModalStack() {
  return useContext(ModalContext);
}
